import { QueryList } from '@angular/core';
import { FlowChartItemComponent } from 'src/app/entity-dashboard/flow-chart/flow-chart.component';

export class TransactionFlowModalPayload {
  items: QueryList<FlowChartItemComponent>;
}
